import { Alert, Badge, Button, Card, Label, Spinner } from "flowbite-react";
import React, { useEffect, useRef, useState } from "react";
import axios from "../../config/axiosInstance";
import { QUERIES } from "../../config/apiConfig";
import { HiInformationCircle } from "react-icons/hi";
import HeaderQuery from "./HeaderQuery";
import usePDF from "../../hooks/usePDF";
import TitleStripe from "../common/TitleStripe";
import CardQueryDescription from "../common/CardQueryDescription";
import SliderToPreview from "../common/SliderToPreview";
import QueryLoading from "../common/QueryLoading";
import FooterQuery from "./FooterQuery";
import { FaPrint } from "react-icons/fa";
import { useReactToPrint } from "react-to-print";
import QueryVehicleInput from "../inputs/QueryVehicleInput";
import moment from "moment";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdBlock, MdInfoOutline } from "react-icons/md";
import { FiAlertOctagon } from "react-icons/fi";
import { formatToReal } from "../../utils/utils";

const BaseEstadualQuery = ({
  query,
  selectedPrice,
  dataFromLocalStorage = null,
  hasHeaderPDF = "true",
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [document, setDocument] = useState("");
  const [isDoneRequest, setIsDoneRequest] = useState(false);
  const [error, setError] = useState("");
  const [errorQuery, setErrorQuery] = useState("");
  const [data, setData] = useState(null);
  const componentRef = useRef();
  const printRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef: printRef });
  const [selectedQueries, setSelectedQueries] = useState([]);
  const { handleClickDownloadPDF, pdfURL, setPdfURL } = usePDF(
    componentRef,
    info,
    query?.id,
    isDoneRequest
  );

  useEffect(() => {
    if (dataFromLocalStorage) {
      setData(dataFromLocalStorage);
      setDocument(dataFromLocalStorage?.dadosCadastrais?.cpf);
      setIsDoneRequest(true);
    }
  }, []);

  const fetchInfo = async (raw) => {
    return await axios(`${QUERIES.GET_V2_QUERY}/base-estadual/${info}`);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDocument(info);

    let isValid = true;

    if (isValid) {
      try {
        setPdfURL("");
        setData(null);
        setIsLoading(true);
        setError("");
        setErrorQuery("");
        setIsDoneRequest(false);
        // Fetch principal
        const { data: dados } = await fetchInfo();
        setData(dados.data);
        setIsLoading(false);
      } catch (error) {
        setErrorQuery(
          typeof error?.response?.data?.message !== "object"
            ? error?.response?.data?.message
            : "Algum erro ocorreu com sua consulta"
        );
        setIsLoading(false);
      } finally {
        setIsDoneRequest(true);
      }
    } else {
      setData(null);
    }
  };

  return (
    <>
      {!dataFromLocalStorage && (
        <>
          <div className="text-lg font-semibold mb-3 title-syncx">
            {query?.name}
          </div>
          <CardQueryDescription
            title="Informações da consulta"
            infos={["Base Nacional"]}
            price={selectedPrice}
          >
            <form
              className="flex flex-col gap-2 bg-white p-2 rounded-lg shadow-md w-fit"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col md:flex-row gap-2 items-center">
                <QueryVehicleInput
                  info={info}
                  setInfo={setInfo}
                  isLoading={isLoading}
                  error={error}
                  type="PLACA"
                />
                <div>
                  {!errorQuery && data && (
                    <Button
                      className="bg-gray-600"
                      onClick={() => reactToPrintFn()}
                    >
                      <div className="flex gap-2 items-center">
                        <FaPrint />
                        <div>Imprimir</div>
                      </div>
                    </Button>
                  )}
                </div>
              </div>
            </form>
          </CardQueryDescription>

          <SliderToPreview />
        </>
      )}

      {errorQuery ? (
        <Alert color="failure" icon={HiInformationCircle}>
          <span className="font-medium">{errorQuery}</span>
        </Alert>
      ) : (
        <>
          <div
            className={`overflow-x-scroll print-content mobile-fit ${
              data || isLoading ? "block" : "hidden"
            }`}
            ref={(el) => {
              componentRef.current = el;
              printRef.current = el;
            }}
          >
            {!isLoading ? (
              <>
                <Card className="p-5 card-pdf relative overflow-hidden">
                  <HeaderQuery
                    title={query?.name}
                    hasHeader={hasHeaderPDF}
                    date={data?.resumoRetorno?.dataConsulta}
                  />

                  <div>
                    <TitleStripe>Quadro de avisos</TitleStripe>
                    <div className="container-alerts three-columns mt-3">
                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes?.ipva
                              ?.existePendencia == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">IPVA</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">IPVA</div>
                                <div className="text-center font-semibold">
                                  R${" "}
                                  {
                                    data?.binEstadual?.restricoes?.ipva
                                      ?.valorPendencia
                                  }
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes?.dpvat
                              ?.existePendencia == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">DPVAT</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">DPVAT</div>
                                <div className="text-center font-semibold">
                                  R${" "}
                                  {
                                    data?.binEstadual?.restricoes?.dpvat
                                      ?.valorPendencia
                                  }
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes?.multas
                              ?.existePendencia == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Multas</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Multas</div>
                                <div className="text-center font-semibold">
                                  R${" "}
                                  {
                                    data?.binEstadual?.restricoes?.multas
                                      ?.valorPendencia
                                  }
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes?.licenciamento
                              ?.existePendencia == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Licenciamento</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Licenciamento</div>
                                <div className="text-center font-semibold">
                                  R${" "}
                                  {
                                    data?.binEstadual?.restricoes?.licenciamento
                                      ?.valorPendencia
                                  }
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.precificador &&
                        data?.precificador?.statusRetorno == 1 && (
                          <>
                            <Alert
                              color="gray"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <MdInfoOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Valor FIPE</div>
                              <div className="text-center font-semibold">
                                {formatToReal(data?.precificador?.valor)}
                              </div>
                            </Alert>
                          </>
                        )}

                      {data?.laudoCsv && data?.laudoCsv?.statusRetorno == 1 && (
                        <>
                          <Alert
                            color="gray"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <MdInfoOutline
                              fontSize={30}
                              className="mx-auto mb-1"
                            />
                            <div className="text-center">Laudo CSV</div>
                            <div className="text-center font-semibold">
                              {data?.laudoCsv?.ocorrencias?.length} ocorrências
                            </div>
                          </Alert>
                        </>
                      )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes
                              ?.existeRestricaoRouboFurto == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Roubo e furto</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Restrição roubo e furto
                                </div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            )}
                          </>
                        )}
                    </div>
                  </div>

                  <div className="mt-5">
                    <div className="flex flex-col gap-10">
                      {data?.binEstadual && (
                        <div className="text-sm flex-1">
                          <div className="title-vehicle mb-3">
                            Informações do veículo - Estadual
                          </div>
                          {data?.binEstadual?.statusRetorno == 1 ? (
                            <div className="p-2 rounded bg-gray-100 grid grid-cols-3 gap-x-3 gap-y-2">
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Marca/Modelo:{" "}
                                </span>
                                {data?.binEstadual?.marcaModelo || "Sem info."}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Ano Fabr./Modelo:{" "}
                                </span>
                                {`${data?.binEstadual?.anoFabricacao}/${data?.binEstadual?.anoModelo}` ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Tempo de circulação:{" "}
                                </span>
                                {`${
                                  moment().format("YYYY") -
                                  +data?.binEstadual?.anoFabricacao
                                } anos` || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Categoria:{" "}
                                </span>
                                {data?.binEstadual?.categoriaVeiculo ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Tipo de veículo:{" "}
                                </span>
                                {data?.binEstadual?.tipoVeiculo ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Placa: </span>
                                {document || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">RENAVAM: </span>
                                {data?.binEstadual?.renavam || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Chassi: </span>
                                {data?.binEstadual?.chassi || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Situação:{" "}
                                </span>
                                {data?.binEstadual?.situacao || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Câmbio: </span>
                                {data?.binEstadual?.caixaCambio ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Capacidade Carga:{" "}
                                </span>
                                {data?.binEstadual?.capacidadeCarga ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Cilindrada:{" "}
                                </span>
                                {data?.binEstadual?.cilindrada ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">CMT: </span>
                                {data?.binEstadual?.cmt || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Combustível:{" "}
                                </span>
                                {data?.binEstadual?.combustivel ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Cor: </span>
                                {data?.binEstadual?.corVeiculo ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Emplacamento:{" "}
                                </span>
                                {data?.binEstadual?.dataEmplacamento ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Espécie: </span>
                                {data?.binEstadual?.especieVeiculo ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Município:{" "}
                                </span>
                                {data?.binEstadual?.municipio ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">uf: </span>
                                {data?.binEstadual?.uf || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nº Carroceria:{" "}
                                </span>
                                {data?.binEstadual?.numeroCarroceria ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Nº DI: </span>
                                {data?.binEstadual?.numeroDI || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Data registro DI:{" "}
                                </span>
                                {data?.binEstadual?.dataRegistroDI ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nº Eixo Auxiliar:{" "}
                                </span>
                                {data?.binEstadual?.numeroEixoAuxiliar ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nº Eixo Traseiro:{" "}
                                </span>
                                {data?.binEstadual?.numeroEixoTrazeiro ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Qtd. Eixos:{" "}
                                </span>
                                {data?.binEstadual?.numeroEixos ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nº Motor:{" "}
                                </span>
                                {data?.binEstadual?.numeroMotor ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">PBT: </span>
                                {data?.binEstadual?.pbt || "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Potência:{" "}
                                </span>
                                {data?.binEstadual?.potenciaVeiculo ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Procedência:{" "}
                                </span>
                                {data?.binEstadual?.procedencia ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Qtd. Passageiros:{" "}
                                </span>
                                {data?.binEstadual?.quantidadePassageiros ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Situação do chassi:{" "}
                                </span>
                                {data?.binEstadual?.situacaoChassi ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Tipo de Carroceria:{" "}
                                </span>
                                {data?.binEstadual?.tipoCarroceria ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Tipo Doc. Faturado:{" "}
                                </span>
                                {data?.binEstadual?.tipoDocumentoFaturado ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Tipo Doc. Importador:{" "}
                                </span>
                                {data?.binEstadual?.tipoDocumentoImportador ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nº Importador:{" "}
                                </span>
                                {data?.binEstadual
                                  ?.numeroIdentificacaoImportador ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Tipo Op. Importação:{" "}
                                </span>
                                {data?.binEstadual
                                  ?.tipoOperacaoImportacaoVeiculo ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Montagem:{" "}
                                </span>
                                {data?.binEstadual?.tipoMontagem ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nº Faturado:{" "}
                                </span>
                                {data?.binEstadual
                                  ?.numeroIdentificacaoFaturado ||
                                  "Não Informado"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  UF Faturamento:{" "}
                                </span>
                                {data?.binEstadual?.ufFaturamento ||
                                  "Não Informado"}
                              </div>
                            </div>
                          ) : (
                            <Alert
                              withBorderAccent
                              color="gray"
                              className="mt-4"
                            >
                              Consulta Indisponível no momento
                            </Alert>
                          )}
                        </div>
                      )}
                    </div>
                    {data?.binEstadual &&
                      data?.binEstadual?.statusRetorno == 1 && (
                        <div className="grid grid-cols-2 gap-3 bg-gray-100 p-2 text-sm">
                          <div>
                            <div className="title-vehicle">
                              Restrições | Estadual
                            </div>
                            {data?.binEstadual?.restricoes
                              ?.existeRestricaoRouboFurto === "0" &&
                            data?.binEstadual?.restricoes?.veiculoBaixado ===
                              "0" &&
                            data?.binEstadual?.restricoes
                              ?.existeRestricaoRenajud === "0" &&
                            data?.binEstadual?.restricoes
                              ?.existeRestricaoGeral === "0" ? (
                              <div className="flex gap-2 items-center font-semibold mt-3">
                                <IoMdCheckmarkCircleOutline color="green" />
                                <div>Não constam restrições</div>
                              </div>
                            ) : (
                              <div className="flex flex-col gap-2 mt-3">
                                {data?.binEstadual?.restricoes
                                  ?.existeRestricaoRouboFurto === "1" && (
                                  <div className="flex gap-2 items-center font-semibold">
                                    <MdBlock color="red" />
                                    <div>Restrição: Roubo e furto</div>
                                  </div>
                                )}

                                {data?.binEstadual?.restricoes
                                  ?.existeRestricaoRenajud === "1" && (
                                  <div className="flex gap-2 items-center font-semibold">
                                    <MdBlock color="red" />
                                    <div>Restrição: renajud</div>
                                  </div>
                                )}

                                {data?.binEstadual?.restricoes
                                  ?.existeRestricaoGeral === "1" && (
                                  <div className="flex gap-2 items-center font-semibold">
                                    <MdBlock color="red" />
                                    <div>Restrição: Geral</div>
                                  </div>
                                )}

                                {data?.binEstadual?.restricoes
                                  ?.veiculoBaixado === "1" && (
                                  <div className="flex gap-2 items-center font-semibold">
                                    <MdBlock color="red" />
                                    <div>Restrição: Veículo Baixado</div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div>
                            <div className="title-vehicle">
                              Multas e débitos | Estadual
                            </div>
                            <div className="flex gap-2 items-center font-semibold mt-3">
                              {data?.binEstadual?.restricoes?.dpvat
                                ?.existePendencia == "1" ? (
                                <MdBlock color="red" />
                              ) : (
                                <IoMdCheckmarkCircleOutline color="green" />
                              )}

                              <div>Débitos: dpvat</div>
                              {data?.binEstadual?.restricoes?.dpvat
                                ?.existePendencia == "1" && (
                                <div>
                                  | R${" "}
                                  {
                                    data?.binEstadual?.restricoes?.dpvat
                                      ?.valorPendencia
                                  }
                                </div>
                              )}
                            </div>
                            <div className="flex gap-2 items-center font-semibold mt-3">
                              {data?.binEstadual?.restricoes?.ipva
                                ?.existePendencia == "1" ? (
                                <MdBlock color="red" />
                              ) : (
                                <IoMdCheckmarkCircleOutline color="green" />
                              )}
                              <div>Débitos: ipva</div>
                              {data?.binEstadual?.restricoes?.ipva
                                ?.existePendencia == "1" && (
                                <div>
                                  | R${" "}
                                  {
                                    data?.binEstadual?.restricoes?.ipva
                                      ?.valorPendencia
                                  }
                                </div>
                              )}
                            </div>
                            <div className="flex gap-2 items-center font-semibold mt-3">
                              {data?.binEstadual?.restricoes?.licenciamento
                                ?.existePendencia == "1" ? (
                                <MdBlock color="red" />
                              ) : (
                                <IoMdCheckmarkCircleOutline color="green" />
                              )}
                              <div>Débitos: licenciamento</div>
                              {data?.binEstadual?.restricoes?.licenciamento
                                ?.existePendencia == "1" && (
                                <div>
                                  | R${" "}
                                  {
                                    data?.binEstadual?.restricoes?.licenciamento
                                      ?.valorPendencia
                                  }
                                </div>
                              )}
                            </div>
                            <div className="flex gap-2 items-center font-semibold mt-3">
                              {data?.binEstadual?.restricoes?.multas
                                ?.existePendencia == "1" ? (
                                <MdBlock color="red" />
                              ) : (
                                <IoMdCheckmarkCircleOutline color="green" />
                              )}
                              <div>Débitos: multas</div>
                              {data?.binEstadual?.restricoes?.multas
                                ?.existePendencia == "1" && (
                                <div>
                                  | R${" "}
                                  {
                                    data?.binEstadual?.restricoes?.multas
                                      ?.valorPendencia
                                  }
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>

                  <FooterQuery hasHeader={hasHeaderPDF} />
                </Card>
              </>
            ) : (
              <QueryLoading />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default BaseEstadualQuery;
